//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Language, ContentCollection, ContentType } from '@constants'
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import { slugify } from '~/utils'

const ARTICLES = gql`
  query ($after: String, $first: Int, $where: ArticleFilterInput, $countFilter: ArticleListingCountFilterInput!) {
    articleListingCount(filter: $countFilter)
    articles(after: $after, first: $first, where: $where, order: [{ date: DESC }]) {
      nodes {
        id
        externalId
        date
        title
        slug
        abstract
        imageUrl
        redirectUrl
        edition {
          id
          name
        }
        country {
          id
          name
        }
        region {
          id
          name
        }
        contentType {
          id
          name
          colour
          contentTypeGroup {
            id
            name
          }
        }
      }
    }
  }
`

const DATA_QUERY = gql`
  query {
    contentCollections(where: { isActive: { eq: true } }, order: [{ order: ASC }], first: 999) {
      nodes {
        id
        name
        slug
      }
    }
    contentTypes(order: [{ order: ASC }], first: 999, where: { isActive: { eq: true } }) {
      nodes {
        id
        name
        websiteTexts(where: { isActive: { eq: true } }) {
          id
          html
          languageId
        }
      }
    }
    regions(first: 999) {
      nodes {
        id
        name
      }
    }
    countries(first: 999) {
      nodes {
        id
        name
      }
    }
  }
`

export default {
  name: 'ArticlesPage',
  components: { ChevronRightIcon, ChevronLeftIcon },
  beforeRouteLeave(to, from, next) {
    const url = new URL(window.location)
    url.searchParams.set('p', this.pagination.page)
    url.searchParams.set('y', window.scrollY)
    window.history.replaceState({}, '', url)
    next()
  },
  scrollToTop: true,
  props: {
    contentTypeId: {
      type: Number,
      required: false,
      default: null
    },
    applyContentCollectionFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    isStrapiPage: {
      type: Boolean,
      required: false,
      default: false
    },
    pageSize: {
      type: Number,
      required: false,
      default: 24
    }
  },
  data() {
    return {
      showPlaceholder: true,
      placeholders: 3,
      timeout: 0,
      articles: [],
      contentCollections: [],
      type: null,
      pagination: {
        total: 0,
        pageSize: this.pageSize,
        page: 1
      },
      ContentType,
      contentTypes: [],
      regions: [],
      countries: [],
      websiteText: null,
      Language
    }
  },
  async fetch() {
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    this.type = this.queryType
    await this.refresh()
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  computed: {
    filters: sync('filters'),
    navbar: sync('navbar'),
    queryType() {
      if (this.contentTypeId) return null

      return this.$route.path.split('/').filter(Boolean)[0]
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    }
  },
  watch: {
    async languageId() {
      await this.refresh(true)
    },
    'filters.options': {
      async handler() {
        this.pagination.page = 1
        await this.fetchArticles()
      },
      deep: true
    }
  },
  fetchOnServer: true,
  beforeDestroy() {
    this.$nuxt.$off('onFiltersClear')
    this.$nuxt.$off('onFilterCollectionChange')
  },
  beforeMount() {
    this.setFilters({ isShow: true, enabled: false, showFilterTotal: true })
    this.$nuxt.$on('onFiltersClear', this.onFiltersClear)
    this.$nuxt.$on('onFilterCollectionChange', this.onFilterCollectionChange)
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    const page = Number(params.get('p'))
    if (page > 0 && page <= this.pagination.pageSize) {
      this.pagination.page = page
    }
    const yPos = Number(params.get('y'))
    if (yPos > 0) {
      setTimeout(() => {
        window.scrollTo(0, yPos)
      }, 1)
    }
    const url = window.location.toString()
    window.history.replaceState({}, '', url.split('?')[0])
  },
  methods: {
    async refresh(purge = false) {
      this.filters.isLoading = true
      this.websiteText = null
      try {
        const { data } = await this.$apollo.query({
          query: DATA_QUERY,
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        this.contentCollections = data.contentCollections.nodes
        this.contentTypes = data.contentTypes.nodes
        this.regions = data.regions.nodes
        this.countries = data.countries.nodes

        this.$nextTick(() => {
          this.updateWebsiteText()
        })

        const lowerType = this.type ? this.type.toLowerCase() : null
        let filterCollection = []

        // Check if slug is a ContentCollections
        if (this.contentCollections.some((x) => x.slug.toLowerCase() === lowerType)) {
          this.filters.options.contentCollectionId = this.contentCollections.filter(
            (x) => x.slug.toLowerCase() === lowerType
          )[0].id
          filterCollection = this.contentCollections.filter((x) => x.id === this.filters.options.contentCollectionId)
        }

        // Check if slug is a ContentTypes
        else if (this.contentTypes.some((x) => slugify(x.name) === lowerType)) {
          this.filters.options.contentTypeId = this.contentTypes.filter((x) => slugify(x.name) === lowerType)[0].id
          filterCollection = this.contentTypes.filter((x) => x.id === this.filters.options.contentTypeId)
        }

        // Check if slug is a Region
        else if (this.regions.some((x) => slugify(x.name) === lowerType)) {
          this.filters.options.regionId = this.regions.filter((x) => slugify(x.name) === lowerType)[0].id
          filterCollection = this.regions.filter((x) => x.id === this.filters.options.regionId)
        }

        // Check if slug is a Country
        else if (this.countries.some((x) => slugify(x.name) === lowerType)) {
          this.filters.options.countryId = this.countries.filter((x) => slugify(x.name) === lowerType)[0].id
          filterCollection = this.countries.filter((x) => x.id === this.filters.options.countryId)
        }

        // Set header by filter ids
        if (filterCollection.length === 0) {
          if (this.contentCollections.some((x) => x.id === this.filters.options.contentCollectionId)) {
            filterCollection = this.contentCollections.filter((x) => x.id === this.filters.options.contentCollectionId)
          } else if (this.contentTypes.some((x) => x.id === this.filters.options.contentTypeId)) {
            filterCollection = this.contentTypes.filter((x) => x.id === this.filters.options.contentTypeId)
          } else if (this.regions.some((x) => x.id === this.filters.options.regionId)) {
            filterCollection = this.regions.filter((x) => x.id === this.filters.options.regionId)
          } else if (this.countries.some((x) => x.id === this.filters.options.countryId)) {
            filterCollection = this.countries.filter((x) => x.id === this.filters.options.countryId)
          }
        }

        if (filterCollection.length === 0 && lowerType === 'press-release') {
          this.filters.options.contentTypeId = ContentType.PRESS_RELEASE
        }

        this.setHeader(filterCollection)

        await this.fetchArticles()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.filters.isLoading = false
      }
    },
    updateWebsiteText() {
      const ct = this.contentTypes.filter((x) => x.id === this.filters.options.contentTypeId)
      if (!ct || ct.length === 0 || !ct[0].websiteTexts || ct[0].websiteTexts.length === 0) {
        this.websiteText = null
        return
      }
      const wt = ct[0].websiteTexts.filter((x) => x.languageId === this.languageId)
      if (!wt || wt.length === 0) {
        this.websiteText = null
        return
      }
      this.websiteText = wt[0].html
    },
    async fetchArticles() {
      this.showPlaceholder = true
      const first = this.pagination.pageSize
      let after = null
      if (this.pagination.page > 1) {
        const id = this.pagination.pageSize * (this.pagination.page - 1) - 1
        after = this.encodeValue(id)
      }
      let where = {}
      if (this.filters.options.countryId != null) {
        where.country = {
          id: {
            eq: this.filters.options.countryId
          }
        }
      }
      if (this.filters.options.regionId != null) {
        where.region = {
          or: [
            { id: { eq: this.filters.options.regionId } },
            {
              and: [
                { parentRegionId: { eq: this.filters.options.regionId } },
                { parentRegionId: { neq: 1 } }, // Global
                { parentRegionId: { neq: 21 } } // Europe
              ]
            }
          ]
        }
      }
      if (this.applyContentCollectionFilter && this.filters.options.contentCollectionId != null) {
        where.contentCollectionArticles = {
          some: {
            contentCollectionId: {
              eq: this.filters.options.contentCollectionId
            }
          }
        }
      }
      if (this.filters.options.contentTypeId != null || this.contentTypeId !== null) {
        where.contentType = {
          id: {
            eq: this.contentTypeId ?? this.filters.options.contentTypeId
          }
        }
      }
      if (
        (this.filters.options.contentCollectionId !== ContentCollection.RESEARCH &&
          this.filters.options.contentTypeId !== ContentType.REPORT) ||
        this.languageId === Language.ENGLISH
      ) {
        where.languageId = {
          eq: this.languageId
        }
      }
      if (Object.keys(where).length === 0) {
        where = null
      }
      try {
        const { data } = await this.$apollo.query({
          query: ARTICLES,
          variables: {
            where,
            countFilter: {
              languageId: where?.languageId?.eq ?? null,
              contentCollectionId: where?.contentCollectionArticles?.some?.contentCollectionId?.eq ?? null,
              contentTypeId: where?.contentType?.id?.eq ?? null,
              countryId: where?.country?.id?.eq ?? null,
              regionId: where?.region?.or?.[0]?.id?.eq ?? null
            },
            first,
            after
          }
        })
        this.articles = data.articles.nodes
        this.pagination.total = data.articleListingCount
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    },
    onFilterCollectionChange() {
      let filterCollection = []

      if (this.contentCollections.some((x) => x.id === this.filters.options.contentCollectionId)) {
        filterCollection = this.contentCollections.filter((x) => x.id === this.filters.options.contentCollectionId)
      } else if (this.contentTypes.some((x) => x.id === this.filters.options.contentTypeId)) {
        filterCollection = this.contentTypes.filter((x) => x.id === this.filters.options.contentTypeId)
      } else if (this.regions.some((x) => x.id === this.filters.options.regionId)) {
        filterCollection = this.regions.filter((x) => x.id === this.filters.options.regionId)
      } else if (this.countries.some((x) => x.id === this.filters.options.countryId)) {
        filterCollection = this.countries.filter((x) => x.id === this.filters.options.countryId)
      }

      if (this.contentTypeId === null) {
        if (filterCollection.length > 0) {
          this.type = filterCollection[0]?.slug ?? slugify(filterCollection[0]?.name)
          window.history.replaceState(null, null, `/${filterCollection[0]?.slug ?? slugify(filterCollection[0]?.name)}`)
        } else {
          this.type = null
          window.history.replaceState(null, null, `/all`)
        }
      }

      this.setHeader(filterCollection)
    },
    setHeader(contentCollection) {
      if ((contentCollection != null && contentCollection.length > 0) || this.navbar.selectedHeader) {
        this.setBreadcrumb({
          isShow: true,
          pageCategory: this.navbar.selectedHeader ? this.navbar.selectedHeader : contentCollection[0].name,
          categoryRedirectUrl: this.navbar.selectedHeader
            ? `/${slugify(this.navbar.selectedHeader)}`
            : `/${contentCollection[0].slug ?? slugify(contentCollection[0].name)}`
        })
        this.filters.header = this.navbar.selectedHeader ? this.navbar.selectedHeader : contentCollection[0].name
        this.$store.set('navbar/selectedHeader', null)
      } else {
        this.setBreadcrumb({
          isShow: true,
          pageCategory: null,
          categoryRedirectUrl: null
        })
        this.filters.header = ''
      }
    },
    async onFiltersClear() {
      this.pagination.page = 1
      this.type = null
      this.setHeader()
      window.history.replaceState(null, null, `/all`)
      await this.fetchArticles()
    },
    async onPaginationChange() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      await this.fetchArticles()
    }
  }
}
